import { DialogContainer } from "../../../components/dialog-container";
import { Button } from "../../../components/ui/button";
import { useLocation } from "wouter";
import { CircleCheckFilled } from "@/lib/icons/circle-check-filled";
import { SuccessDialogProps } from "../sign-up.types";

export function SuccessDialog({ open, onOpenChange }: SuccessDialogProps) {
  const [, navigate] = useLocation();

  return (
    <DialogContainer
      open={open}
      onOpenChange={onOpenChange}
      title={""}
      children={
        <div className="flex flex-col items-center gap-2">
          <CircleCheckFilled className="text-primary" size={40} />

          <div className="text-center">
            <span className="text-black text-2xl font-bold">
              Cadastrado
            </span>
            <p className="text-black text-2xl font-bold">
              com Sucesso!
            </p>
          </div>

          <p className="text-gray-600 text-md">
            Acesse a plataforma e finalize o seu cadastro!
          </p>

          <Button type="button" onClick={() => navigate("/onboarding")}>Acessar o Sistema</Button>
        </div>
      }
    />
  );
}
